<template>
  <div>
    <!-- Main Content -->
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">Dados do Usuário</div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-10">
                  <form action>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userName">
                            <span class="required">*</span> Nome
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="userName"
                            :value="users.name"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userRG">
                            <span class="required">*</span> Matrícula
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            v-model="users.matriculation"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userRG">
                            <span class="required">*</span> RG
                          </label>
                          <input
                            v-mask="'##.###.###-#'"
                            type="text"
                            class="form-control"
                            id="userRG"
                            :value="users.rg"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userCPF">
                            <span class="required">*</span> CPF
                          </label>
                          <input
                            vmask="'###.###.###-##'"
                            type="text"
                            class="form-control"
                            id="userCPF"
                            :value="users.cpf"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userEmail">
                            <span class="required">*</span> E-mail
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="userEmail"
                            :value="users.email"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userCellphone">
                            <span class="required">*</span> Celular
                          </label>
                          <input
                            v-mask="'(##) #####-####'"
                            type="text"
                            class="form-control"
                            id="userCellphone"
                            :value="users.cellphone"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userDateOfBirth">
                            <span class="required">*</span> Data Nascimento
                          </label>
                          <input
                            type="text"
                            v-mask="'##/##/####'"
                            class="form-control"
                            id="userDateOfBirth"
                            v-model="users.e_date_of_birth"
                            placeholder=""
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userNumberCNH">
                            <span class="required">*</span> Número da CNH
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="userNumberCNH"
                            :value="users.number_cnh"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userDateValidityCNH">
                            <span class="required">*</span> Data de Validade da
                            CNH
                          </label>
                          <input
                            type="text"
                            v-mask="'##/##/####'"
                            class="form-control"
                            id="userDateValidityCNH"
                            v-model="users.e_validity_cnh"
                            placeholder=""
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userDatePriCNH">
                            <span class="required">*</span> Data Primeira
                            Habilitação
                          </label>
                          <input
                            v-maks="'##/##/####'"
                            type="date"
                            class="form-control"
                            id="userDatePriCNH"
                            :value="users.pri_cnh"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userCateg">
                            <span class="required">*</span> Categoria da CNH
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="catCNH"
                            :value="users.cat_cnh"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userDepartment">
                            <span class="required">*</span> Departamento
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            id="userDepartment"
                            :value="users.departments.description"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userPosition">
                            <span class="required">*</span> Data Admissão
                          </label>
                          <input
                            vmask="'##/##/####'"
                            type="date"
                            class="form-control"
                            id="userDateAdmission"
                            :value="users.admission_date"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="userPosition">
                            <span class="required">*</span> Aceitou Termos de
                            Utilização?
                          </label>
                          <select
                            v-model="users.accept_terms"
                            class="form-control"
                            disabled
                          >
                            <option value="0">Não</option>
                            <option value="1">Sim</option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-4" v-if="users.date_accept">
                        <div class="form-group">
                          <label for="userPosition">
                            <span class="required">*</span> Data do Aceite
                          </label>
                          <input
                            type="text"
                            step="2"
                            class="form-control"
                            id="userDateAdmission"
                            :value="users.date_accept"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="col-md-2">
                  <div class="circular--landscape">
                    <img
                      v-if="previewImage"
                      :src="previewImage"
                      width="100%"
                      height="198"
                      class="tratament"
                    />
                    <img
                      v-else
                      :src="users.photo"
                      alt
                      width="100%"
                      height="185"
                      class="tratament"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="card-header">
              <div class="card-title">Filiais Vinculadas</div>
            </div>

            <table class="table table-hover">
              <thead>
                <tr>
                  <th scope="col">Filial</th>
                  <th scope="col">Cidade</th>
                  <th scope="col">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="branch in users.branches" :key="branch.id">
                  <td>{{ branch.description }}</td>
                  <td>
                    {{ branch.cities ? branch.cities.title : branch.city }}
                  </td>
                  <td>
                    {{ branch.states ? branch.states.title : branch.state }}
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
            <div class="col-md-12 text-right">
              <router-link to="/users" class="btn btn-back">
                <i class="fa fa-arrow-left"></i> Voltar
              </router-link>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: {
        name: "",
        email: "",
        password: "",
        registry: "",
        photo: "",
        departments: {
          description: "",
        },
      },
      branches: {
        cities: [
          {
            title: "",
          },
        ],
        states: [
          {
            title: "",
          },
        ],
      },
      errors: undefined,
    };
  },
  computed: {},
  methods: {
    getUsers: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api +
        "users/" +
        id +
        "?with[]=branches&with[]=departments";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data[0];
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted: function () {
    this.getUsers();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/User/View.vue